import { AppMainPage } from "../mainpage/AppMainPage";
import { AppRouterProps } from "./AppRouterProps";
import { Router } from "@mcleod/common";
import { RegisteredRoutes } from "@mcleod/core";

export class AppRouter extends Router {
    private _shouldHideFooter: boolean

    constructor(props: Partial<AppRouterProps>) {
        super(props);
    }

    public override get defaultRouterPadding(): number {
        return 0;
    }

    private syncFooter() {
        const mainPage = AppMainPage.instance;
        if (mainPage != null && mainPage.footer != null) {
            const shouldShowFooter = this.isPageWithFooter(this._route);
            const footerAlreadyPresent = mainPage.contains(mainPage.footer);
            if (shouldShowFooter && !footerAlreadyPresent)
                mainPage.add(mainPage.footer);
            else if (!shouldShowFooter && footerAlreadyPresent)
                mainPage.remove(mainPage.footer);
        }
    }

    private isPageWithFooter(page: string): boolean {
        return !this.shouldHideFooter &&
            page !== RegisteredRoutes.sessionExpirationRoute &&
            RegisteredRoutes.hasPageHeader(page);
    }

    public get shouldHideFooter(): boolean {
        return this._shouldHideFooter;
    }

    public set shouldHideFooter(value: boolean) {
        this._shouldHideFooter = value;
        this.syncFooter();
    }

    static get instance(): AppRouter {
        if (Router.instance == null)
            new AppRouter({
                shouldHideFooter: AppMainPage.instance.shouldHideFooter
            }); // The parent will set its own ._instance value.
        return Router.instance as AppRouter;
    }
}
